import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

// this one controls the label purchase modal, despite the other one being named that.
export const useEnableUpsTerms2 = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableUpsTerms2);
};
